import { render, staticRenderFns } from "./ReportOtp.vue?vue&type=template&id=86097c6e&scoped=true&"
import script from "./ReportOtp.vue?vue&type=script&lang=js&"
export * from "./ReportOtp.vue?vue&type=script&lang=js&"
import style0 from "./ReportOtp.vue?vue&type=style&index=0&id=86097c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86097c6e",
  null
  
)

export default component.exports